/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'edit': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M11.59 1.585a1.996 1.996 0 112.825 2.824l-9.532 9.532L1 15l1.06-3.883 9.53-9.532z"/>'
  }
})
